import "@mantine/core/styles.css";

import { DirectionProvider, MantineProvider } from "@mantine/core";
import { dovachTheme } from "@dovach/ui-primitives";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <DirectionProvider initialDirection="rtl">
      <MantineProvider theme={dovachTheme} defaultColorScheme="auto">
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MantineProvider>
    </DirectionProvider>
  </React.StrictMode>,
);
